<template>
  <CCard>
    <CCardHeader>
      <strong>{{ this.$lang.dashboard.header.recent_project }}</strong>
      <span style="float: right;">
        <CBadge color="success">{{ count }}</CBadge>
      </span>
    </CCardHeader>
    <CCardBody>
      <CDataTable class="mb-0 table-outline" hover :items="tableItems" :fields="tableFields"
                  @row-clicked="rowClickHandler" head-color="light" no-sorting>
        <td slot="avatar" class="text-center" slot-scope="{ item }">
          <div class="c-avatar">
            <img :src="item.avatar" class="c-avatar-img" alt=""/>
          </div>
        </td>
        <td slot="name" slot-scope="{ item }">
          <span :title="item.name">{{ trimfunction(item.name, 25) }}</span>
        </td>
        <td slot="detail" slot-scope="{ item }">
          <div>{{ item.profilerName }}</div>
          <div class="small text-muted">
            <span>
              <template> Industry: {{ item.industry }}</template>
            </span>
          </div>
        </td>
        <td slot="description" slot-scope="{ item }">
          <span :title="item.description">{{ trimfunction(item.description, 15) }}</span>
        </td>
      </CDataTable>
      <CRow v-if="showProfile" style="margin-top: 2px">
        <CCol class="col-12 text-right">
          <button title="View All Profile" v-on:click="viewOpportunitys" class="btn btn-light btn-block mb-1">
            View All
          </button>
        </CCol>
      </CRow>
    </CCardBody>
  </CCard>
</template>
<script>
import Vue from "vue";
import {ServerTable} from "vue-tables-2";
import store from "../../store/store";
import {Mixin} from "/src/mixins/index.js";
import {dashboardrecentOpportunityList} from "../../store/url";

Vue.use(ServerTable, {}, false);
export default {
  name: "RecentOpportunitys",
  mixins: [Mixin],
  data() {
    return {
      self: this,
      count: 0,
      showProfile: false,
      moduleDashboardrecentOpportunityList: dashboardrecentOpportunityList,
      tableItems: [],
      tableFields: [
        {key: "avatar", label: "", _classes: "text-center"},
        {key: "detail", label: this.$lang.dashboard.recentOpportunity.detail},
        {key: "name", label: this.$lang.dashboard.recentOpportunity.name},
        {key: "description", label: this.$lang.dashboard.recentOpportunity.description},
      ],
    };
  },
  mounted() {
    let self = this;
    store.commit("showLoader", false); // Loader Off
    axios.get(this.listUrlApi(this.moduleDashboardrecentOpportunityList))
        .then((response) => {
          self.tableItems = response.data.data;
          self.count = response.data.count;
          if (response.data.data.length > 0) {
            self.showProfile = true;
          }
        });
  },
  methods: {
    rowClickHandler(item) {
      this.$router.push({path: `projects/view/${item.id}`});
    },
    viewOpportunitys() {
      this.$router.push({path: `projects`});
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
